class framePopup extends HTMLElement {
  constructor() {
    super();

    this.isOpen = this.hasAttribute('open');
    this.frameContent = this.querySelector('frame-content');
    this.contents = this.querySelector('.quick-view__content');
    this.closeBtn = this.querySelector('.close-btn');

    this.init();
  }

  init() {
    if (this.isOpen) {
      this.showPopup();
    }

    this.closeBtn.addEventListener('click', () => this.hidePopup());
    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'FRAME-POPUP') this.hidePopup();
    });
  }

  showPopup() {
    this.style.display = 'flex'; // Or another way to make it visible
  }

  hidePopup() {
    // this.contents.style.display = 'none';
    this.frameContent.style.display = 'none'; // Or another way to hide it
    this.removeAttribute('open');
    document.querySelector('body').classList.remove('quick-view--open');
    this.contents.innerHTML = ''; // Remove all contents
  }

  static get observedAttributes() {
    return ['open'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'open') {
      if (newValue !== null) {
        this.showPopup();
      } else {
        this.hidePopup();
      }
    }
  }
}

customElements.define("frame-popup", framePopup);
